var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64701 19L14.5294 19L6.8823 9.5L14.5294 9.53674e-06L7.64701 8.93507e-06L-4.49459e-05 9.5L7.64701 19Z",
    fill: "#37A0F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7647 17.8823L24.5882 17.8823L18.1176 9.49997L24.5882 1.11763L18.7647 1.11763L12.2941 9.49997L18.7647 17.8823Z",
    fill: "#37A0F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeft);
export default __webpack_public_path__ + "static/media/double_left.da1b36b24238dc88dd11934393ecb64e.svg";
export { ForwardRef as ReactComponent };